import { useModalMeta } from "@/shared/atoms/useModal";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";

const QrModal = ({ onExit, ...props }: ModalProps) => {
  const [meta] = useModalMeta();
  const showLink = meta?.showLink ?? false;
  const { t } = useTranslation("");
  return (
    <Modal width={"58rem"} onExit={onExit} {...props}>
      <h1>{t("qrTitle")}</h1>
      <QRCode
        style={{ height: "auto", maxWidth: "50rem", width: "100%" }}
        value={meta.url}
        viewBox={`0 0 256 256`}
      />
      {showLink && (
        <a target="_blank" rel="no-opener" href={meta.url} className="my-[2rem] block">
          {t("qrLink")}
        </a>
      )}
      <Button onClick={() => onExit()}>{t("close")}</Button>
    </Modal>
  );
};

export default QrModal;
